import * as api from './constants'

export function updateFilteredDate (query) {
  return axios.get(api.UPDATE_FILTERED_DATE, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}



// WEBPACK FOOTER //
// ./app/api/update-filtered-date.js